import { useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import {getadBannerData} from '../store/slices/adBannerSlice';
import { useLocation } from "react-router-dom";
export const useAdBanner= () => {

    const dispatch = useDispatch();
    const  adBannerData = useSelector((state)=>state.adbanner)

    useEffect(() => {
        dispatch(getadBannerData())
    }, []);

    return adBannerData?.adBannerData;
}